<template>
  <div class="flex h-full w-full">
    <div class="flex h-full min-h-screen w-full">
      <!-- <div
        class="workspace-switcher sticky top-0 h-screen overflow-y-auto border-r border-gray-400 bg-gray-900 dark:border-gray-600 dark:bg-black"
      >
        <AppSidebar />
      </div> -->

      <div
        class="mobile:min-w-0 flex w-full min-w-full flex-col overflow-y-auto"
      >
        <NotificationBanner />

        <slot name="header">
          <NavBar>
            <template v-slot:title> </template>
            <template v-slot:rightcontrols>
              <slot name="rightcomp"></slot>
            </template>

            <template v-slot:centercontrols>
              <slot name="centercomp" />
            </template>
          </NavBar>
        </slot>

        <slot />
      </div>
    </div>
  </div>
</template>
<script>
const NavBar = () => import('@components/navbar/NavBar')
const NotificationBanner = () => import('@components/NotificationBanner')
const AppSidebar = () => import('@components/sidebar/AppSidebar')

export default {
  components: { NavBar, NotificationBanner, AppSidebar }
}
</script>
